import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../../i18n";

export const Faq = () => {
  const { t } = useLang();
  const faqs = [
    { q: t("faq.q1"), a: t("faq.a1") },
    { q: t("faq.q2"), a: t("faq.a2") },
    { q: t("faq.q3"), a: t("faq.a3") },
  ];

  return (
    <section id="faq" data-testid="faq-section" className="bg-[#F3EFE6] py-24 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4">
          <Reveal><Eyebrow>{t("faq.eyebrow")}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#1C1917]">
              {t("faq.h2a")} <em className="text-[#9A4930]">{t("faq.h2em")}</em> {t("faq.h2b")}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base md:text-lg text-[#57534E] leading-relaxed">{t("faq.p")}</p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          {faqs.map((f, i) => (
            <Reveal key={f.q} delay={0.08 * i}>
              <div data-testid={`faq-item-${i}`} className="py-8 lg:py-10 border-t border-[#D9D0C1] last:border-b grid md:grid-cols-[auto_1fr] gap-4 md:gap-10">
                <span className="font-mono text-xs text-[#9A4930] pt-2">{`0${i + 1}`}</span>
                <div>
                  <h3 className="font-serif text-2xl lg:text-3xl text-[#1C1917]">{f.q}</h3>
                  <p className="mt-3 text-sm md:text-base text-[#57534E] leading-relaxed">{f.a}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
